module.exports = __webpack_public_path__ + "files/e0ddd89060838ca9d4316d2fa9e5b274.png";